import { render, staticRenderFns } from "./commercialData.vue?vue&type=template&id=ccded466"
import script from "./commercialData.vue?vue&type=script&lang=js"
export * from "./commercialData.vue?vue&type=script&lang=js"
import style0 from "./commercialData.vue?vue&type=style&index=0&id=ccded466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports